<template>
  <div class="calendar-header">
    <h2>Store Schedule Calendar</h2>
    <div class="store-selector">
      <Dropdown
        v-model="selectedStoreModel"
        :options="stores"
        optionLabel="name"
        optionValue="id"
        placeholder="Select Store"
        class="store-dropdown"
      />
      <Button
        v-if="isAdmin"
        label="Add Shift"
        icon="pi pi-plus"
        @click="$emit('addShiftRequested')"
        class="add-shift-button p-button-success"
      />
      <Button
        v-if="isAdmin"
        label="Auto-Schedule"
        icon="pi pi-bolt"
        @click="$emit('autoScheduleRequested')"
        class="auto-schedule-button p-button-help"
      />
      <Button
        label="Email"
        icon="pi pi-envelope"
        @click="$emit('emailRequested')"
        class="email-button"
      />
      <Button
        label="Print"
        icon="pi pi-print"
        @click="$emit('printRequested')"
        class="print-button"
      />
    </div>
  </div>
</template>

<script>
import { computed } from "vue";
import { useAuthStore } from "../../stores/authStore";

export default {
  name: "CalendarHeader",

  props: {
    selectedStore: {
      type: Object,
      default: null,
    },
    stores: {
      type: Array,
      default: () => [],
    },
  },

  emits: ["update:selectedStore", "printRequested", "emailRequested", "addShiftRequested", "autoScheduleRequested"],

  setup(props, { emit }) {
    const authStore = useAuthStore();
    const isAdmin = computed(() => authStore.isAdmin);

    // Create a computed property that acts as a two-way binding
    const selectedStoreModel = computed({
      get: () => {
        return props.selectedStore ? props.selectedStore.id : null;
      },
      set: (value) => {
        // Find the store object with the selected ID
        const store = props.stores.find((s) => s.id === value);
        emit("update:selectedStore", store);
      },
    });

    return {
      selectedStoreModel,
      isAdmin,
    };
  },
};
</script>

<style scoped>
.calendar-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}
.store-selector {
  display: flex;
  gap: 1rem;
  align-items: center;
}
.store-dropdown {
  min-width: 200px;
}
</style>
